export default __webpack_public_path__ + "static/guide-bg.sized-7f29e9654da33fdec900a60ac94ca276.png";